import React from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import LeaguesTable from '../../shared/Tables/LeaguesTable';
import AddLeague from './AddLeague';

class LeaguesAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			leagues: []
		};

		this.loadLeagues = this.loadLeagues.bind(this);
	}

	componentDidMount() {
		// console.log('LeaguesAdmin: componentDidMount');
		this.loadLeagues();
	}

	loadLeagues() {
		// console.log('LeaguesAdmin: loadLeagues');
		var _this = this;
		Axios.get('/api/leagues').then(function(response) {
			_this.setState({
				leagues: response.data
			})
		});
	}

	render() {
		//console.log('Admin - LeaguesAdmin: render')
		return (
			<div className="row">
			<div className="col-12">

				<div className="row">
				<div className="col-md-6">
					<h5>Liste des ligues</h5>
					<div className="card">
						<div className="card-header">
							<i className="fa fa-th-large"></i> Ligues
						</div>
						<div className="card-block">
							<LeaguesTable leagues={this.state.leagues} /*handleDeleteLeague={this.handleDeleteLeague} leagueChange={this.props.leagueChange}*//>
						</div>
					</div>
				</div>

				<div className="col-md-6">
					<AddLeague loadLeagues={this.loadLeagues} />
				</div>
				</div>
			
			</div>
			</div>
		);
	}

}

export default LeaguesAdmin;